export default __webpack_public_path__ + "static/media/squared-corners-2.b5b1f2c5.webp";